export const netPrice = {
    default: true,
    b2bwebolympia: true,
    b2bweberoski: true,
    b2bwebdawson: false
};


// WEBPACK FOOTER //
// ./src/defaultValues/netPrice.js